export const marketingConsentDisclosure = (clinic) => `Send me offers and news from ${clinic} by email, SMS and WhatsApp.`;
/** The import box, ticked by default: the clinic authorises marketing for the
 * people in the file. The same wording is stored with each opt-in. */
export const importMarketingAuthorization = (clinic) => `These people agreed to get offers and news from ${clinic?.trim() || 'us'}.`;
//# sourceMappingURL=marketing-consent.js.map